module.exports = __webpack_public_path__ + "media/servicesPages/listIcon1-89c8f1f5.png";